/**
 * Refresh button used by every report. Calls the supplied refetch() and spins
 * the icon while fetching. Doesn't change any dates — just re-pulls.
 */
export function RefreshButton({
  onRefresh,
  isFetching,
}: {
  onRefresh: () => void;
  isFetching: boolean;
}) {
  return (
    <button
      type="button"
      className="btn-secondary"
      onClick={onRefresh}
      disabled={isFetching}
      title="Re-pull the report from the server"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 12,
        padding: '4px 10px',
      }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        style={isFetching ? { animation: 'spin 1s linear infinite' } : undefined}
      >
        <polyline points="23 4 23 10 17 10" />
        <polyline points="1 20 1 14 7 14" />
        <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
      </svg>
      {isFetching ? 'Refreshing…' : 'Refresh'}
    </button>
  );
}
